import filter from 'lodash/filter';
import get from 'lodash/get';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import {
    LIKED_EVENTS,
    ORGANIZER_ARTICLE_TYPE,
    SMALL_CITY_FALLBACK,
} from '../../../constants/constants';
import { Events } from '../../../types/index';

const _getEventBucketsKeys = (buckets?: { key?: string; type?: string }[]) => {
    let bucketKeys = [];

    /* This was using a constant named EVENT_TYPE = 'any' which failed all the time because that's not a key
     * in our buckets.
     */
    bucketKeys = filter(buckets, ({ type }) => type === 'event');
    bucketKeys = map(bucketKeys, 'key');
    bucketKeys = filter(
        bucketKeys,
        (value) =>
            value !== (LIKED_EVENTS as string) ||
            value !== (ORGANIZER_ARTICLE_TYPE as string),
    );

    return bucketKeys;
};

export const isSmallCityFallback = ({
    buckets,
    events,
}: {
    buckets?: { key?: string; type?: string }[];
    events?: Events;
}) => {
    let isSmallCity = true;

    if (!isEmpty(buckets)) {
        const keys = _getEventBucketsKeys(buckets);

        isSmallCity = includes(keys, SMALL_CITY_FALLBACK);
    } else if (!isEmpty(events)) {
        const smallCityEventsLength = 8;
        const firstEventBucketLength = events?.[0]
            ? get(events?.[0], 'events.length', 0)
            : get(events, 'length', 0);

        isSmallCity = firstEventBucketLength < smallCityEventsLength;
    }

    return isSmallCity;
};

export const isZeroContent = ({
    buckets,
    events,
}: {
    buckets?: { key?: string; type?: string }[];
    events?: Events;
}) => {
    let response = true;

    if (!isEmpty(buckets)) {
        const keys = _getEventBucketsKeys(buckets);

        response = isEmpty(keys);
    } else if (!isEmpty(events)) {
        const firstEventBucket = (events?.[0] && events[0].events) || events;

        response = isEmpty(firstEventBucket);
    }

    return response;
};
